import { render, staticRenderFns } from "./left-box.vue?vue&type=template&id=634b1f4c&"
import script from "./left-box.vue?vue&type=script&lang=js&"
export * from "./left-box.vue?vue&type=script&lang=js&"
import style0 from "./left-box.vue?vue&type=style&index=0&id=634b1f4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports